import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Heart, Star, CheckCircle2, User } from 'lucide-react';
interface Comment {
  id: number;
  handle: string;
  comment: string;
  likes: number;
  time: string;
  rating: number;
  liked?: boolean;
}
const initialComments: Comment[] = [{
  id: 1,
  handle: '@ajarn_somchai_bkk',
  comment: 'ฉันนำระบบวางแผนรายสัปดาห์ไปใช้ตั้งแต่สัปดาห์แรก ประหยัดเวลาได้มากกว่า 10 ชั่วโมงต่อสัปดาห์ คุ้มค่ามาก',
  likes: 47,
  time: '3 ชั่วโมงที่แล้ว',
  rating: 5,
  liked: true
}, {
  id: 2,
  handle: '@coach_wilai_chiangmai',
  comment: 'ภายในสองสัปดาห์ลดเวลาเตรียมการสอนได้ 80% โดยไม่ต้องเปลี่ยนวิธีการสอนเลย แค่ใช้เช็กลิสต์',
  likes: 32,
  time: '5 ชั่วโมงที่แล้ว',
  rating: 5
}, {
  id: 3,
  handle: '@prasit_coach_kkn',
  comment: 'ส่วนของการรายงานผู้ปกครองเปิดตาฉันมาก ฉันไม่เคยมีระบบที่ชัดเจนแบบนี้มาก่อน',
  likes: 28,
  time: '8 ชั่วโมงที่แล้ว',
  rating: 5,
  liked: true
}, {
  id: 4,
  handle: '@nattapong_football',
  comment: 'เนื้อหาเยอะมาก ตอนแรกคิดว่าจะใช้ไม่หมด แต่พอจัดระบบแล้ว มีประโยชน์ทุกหน้าเลย',
  likes: 19,
  time: '12 ชั่วโมงที่แล้ว',
  rating: 5
}, {
  id: 5,
  handle: '@malee_academy_phuket',
  comment: 'แผนสำรองวันฝนตกช่วยชีวิตฉันไว้หลายครั้งมาก ก่อนหน้านี้ทุกครั้งที่ฝนตกคือความวุ่นวายทันที',
  likes: 24,
  time: 'เมื่อวานนี้',
  rating: 5,
  liked: true
}];
const moreCommentsPool: Comment[] = [{
  id: 6,
  handle: '@coach_anan_bkk',
  comment: 'แบบฝึกหัดความคล่องตัวในเล่มที่ 2 เด็กๆ ชอบมาก พัฒนาการเห็นได้ชัดในเดือนเดียว',
  likes: 18,
  time: '6 ชั่วโมงที่แล้ว',
  rating: 5
}, {
  id: 7,
  handle: '@academy_thai_korat',
  comment: 'ใช้คลังเกมวอร์มอัพ 30 แบบทุกคลาส เด็กไม่เบื่อเลย ขอบคุณทีมงานมากครับ',
  likes: 31,
  time: '14 ชั่วโมงที่แล้ว',
  rating: 5,
  liked: true
}, {
  id: 8,
  handle: '@somsak_trainer',
  comment: 'ปฏิทินการฝึกซ้อมตลอดปีช่วยให้ผมวางแผนล่วงหน้าได้อย่างมืออาชีพ ราคาคุ้มเกินคาด',
  likes: 22,
  time: '18 ชั่วโมงที่แล้ว',
  rating: 5
}, {
  id: 9,
  handle: '@kru_football_cnx',
  comment: 'ผู้ปกครองชมว่ามีระบบดีมาก ใช้แบบฟอร์มรายงานเดือนนี้แล้วได้รับ feedback ดีๆ เยอะเลย',
  likes: 41,
  time: 'เมื่อวานนี้',
  rating: 5,
  liked: true
}, {
  id: 10,
  handle: '@coach_pim_pattaya',
  comment: 'ดาวน์โหลดได้ทันทีจริงๆ ใช้บนแท็บเล็ตที่สนามสะดวกมาก ไม่ต้องพิมพ์ก็ใช้ได้',
  likes: 15,
  time: 'เมื่อวานนี้',
  rating: 5
}, {
  id: 11,
  handle: '@football_thai_ubon',
  comment: 'คู่มือแบ่งกลุ่มเด็กช่วยจัดการคลาส 30+ คนได้ง่ายขึ้นเยอะ แนะนำเพื่อนโค้ชแล้วครับ',
  likes: 27,
  time: '2 วันที่แล้ว',
  rating: 5,
  liked: true
}, {
  id: 12,
  handle: '@anucha_coach',
  comment: 'แผ่นสรุปโค้ช 1 หน้าต่อคลาสคือสิ่งที่ผมต้องการมานาน เตรียมการสอนเร็วขึ้น 3 เท่า',
  likes: 19,
  time: '2 วันที่แล้ว',
  rating: 5
}];
export function SocialFeed() {
  const [comments, setComments] = useState<Comment[]>(initialComments);
  const [loadedExtra, setLoadedExtra] = useState(0);
  const [newComment, setNewComment] = useState('');
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [showThankYou, setShowThankYou] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newComment.trim()) return;
    setShowThankYou(true);
    setNewComment('');
    setRating(0);
    setTimeout(() => setShowThankYou(false), 4500);
  };
  const toggleLike = (id: number) => {
    setComments(prev => prev.map(c => c.id === id ? {
      ...c,
      liked: !c.liked,
      likes: c.liked ? c.likes - 1 : c.likes + 1
    } : c));
  };
  const loadMore = () => {
    const next = moreCommentsPool.slice(loadedExtra, loadedExtra + 5);
    setComments(prev => [...prev, ...next]);
    setLoadedExtra(prev => prev + 5);
  };
  const hasMore = loadedExtra < moreCommentsPool.length;
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-224">
      <div className="max-w-3xl mx-auto" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-226">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-navy-primary mb-2 md:mb-3" data-id="element-227">
            ความคิดเห็นจากผู้ที่เข้าถึงระบบแล้ว
          </h2>
          <p className="text-sm md:text-base text-gray-600" data-id="element-228">
            อาจารย์กว่า 1,200 ท่านได้เปลี่ยนแปลงการสอนของตัวเองแล้ว
          </p>
        </motion.div>

        {/* Comment Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-lg p-5 md:p-8 mb-6 md:mb-8 border border-gold-accent/20" data-id="element-229">
          <h3 className="text-lg md:text-xl font-bold text-navy-primary mb-3 md:mb-4" data-id="element-230">
            ฝากความคิดเห็นของคุณ:
          </h3>

          <AnimatePresence mode="wait" data-id="element-231">
            {showThankYou ? <motion.div key="thanks" initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} className="bg-green-50 border border-green-200 rounded-xl p-4 md:p-6 flex items-start gap-3 md:gap-4" data-id="element-232">
                <CheckCircle2 className="w-6 h-6 md:w-8 md:h-8 text-green-600 flex-shrink-0" data-id="element-233" />
                <div data-id="element-234">
                  <p className="font-bold text-green-800 text-base md:text-lg mb-1" data-id="element-235">
                    ขอบคุณสำหรับความคิดเห็นของคุณ!
                  </p>
                  <p className="text-sm md:text-base text-green-700" data-id="element-236">
                    ความคิดเห็นของคุณจะถูกเผยแพร่ในไม่ช้านี้หลังจากการตรวจสอบ
                  </p>
                </div>
              </motion.div> : <motion.form key="form" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} onSubmit={handleSubmit} data-id="element-237">
                <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="เขียนประสบการณ์ของคุณกับระบบฟุตบอล พร้อม..." rows={3} className="w-full p-3 md:p-4 rounded-xl border border-gray-200 focus:border-gold-accent focus:outline-none transition-colors resize-none text-sm md:text-base text-gray-700 placeholder-gray-400" data-id="element-238" />

                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mt-4" data-id="element-239">
                  <div className="flex items-center gap-2 md:gap-3" data-id="element-240">
                    <span className="text-sm md:text-base text-gray-600 font-medium" data-id="element-241">
                      ให้คะแนน:
                    </span>
                    <div className="flex gap-1" data-id="element-242">
                      {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} onClick={() => setRating(star)} className="transition-transform hover:scale-110" aria-label={`ให้ ${star} ดาว`} data-id="element-243">
                          <Star className={`w-6 h-6 md:w-7 md:h-7 transition-colors ${(hoverRating || rating) >= star ? 'fill-gold-accent text-gold-accent' : 'text-gray-300'}`} data-id="element-244" />
                        </button>)}
                    </div>
                  </div>

                  <motion.button type="submit" whileHover={{
                scale: 1.03
              }} whileTap={{
                scale: 0.97
              }} disabled={!newComment.trim()} className="bg-navy-primary hover:bg-navy-dark text-white font-bold px-6 py-2.5 md:px-8 md:py-3 rounded-full shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm md:text-base w-full sm:w-auto" data-id="element-245">
                    ส่งความคิดเห็น
                  </motion.button>
                </div>
              </motion.form>}
          </AnimatePresence>
        </motion.div>

        {/* Comments List */}
        <div className="space-y-4" data-id="element-246">
          <AnimatePresence data-id="element-247">
            {comments.map((comment, index) => <motion.div key={comment.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.4,
            delay: index < 5 ? index * 0.05 : 0
          }} className="bg-white rounded-2xl p-4 md:p-6 shadow-sm border border-gray-100" data-id="element-248">
                <div className="flex items-start justify-between gap-3 mb-2" data-id="element-249">
                  <div className="flex items-center gap-2 md:gap-3 min-w-0" data-id="element-250">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-navy-primary flex items-center justify-center flex-shrink-0" data-id="element-251">
                      <User className="w-4 h-4 md:w-5 md:h-5 text-gold-accent" data-id="element-252" />
                    </div>
                    <span className="font-bold text-navy-primary text-sm md:text-base truncate" data-id="element-253">
                      {comment.handle}
                    </span>
                  </div>
                  <div className="flex gap-0.5 flex-shrink-0" data-id="element-254">
                    {[...Array(comment.rating)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 fill-gold-accent text-gold-accent" data-id="element-255" />)}
                  </div>
                </div>

                <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3" data-id="element-256">
                  {comment.comment}
                </p>

                <div className="flex items-center gap-3 md:gap-4 text-xs md:text-sm" data-id="element-257">
                  <button onClick={() => toggleLike(comment.id)} className="flex items-center gap-1.5 group" aria-label="ถูกใจ" data-id="element-258">
                    <Heart className={`w-4 h-4 md:w-5 md:h-5 transition-all group-hover:scale-110 ${comment.liked ? 'fill-red-500 text-red-500' : 'text-gray-400 group-hover:text-red-400'}`} data-id="element-259" />
                    <span className={comment.liked ? 'text-red-500 font-medium' : 'text-gray-500'} data-id="element-260">
                      {comment.likes} ถูกใจ
                    </span>
                  </button>
                  <span className="text-gray-400" data-id="element-261">•</span>
                  <span className="text-gray-500" data-id="element-262">{comment.time}</span>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {/* Load More Button */}
        {hasMore && <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center mt-6 md:mt-8" data-id="element-263">
            <motion.button whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} onClick={loadMore} className="bg-white hover:bg-cream-bg text-navy-primary font-bold px-6 py-2.5 md:px-8 md:py-3 rounded-full shadow-sm border border-navy-primary/10 hover:border-gold-accent transition-all text-sm md:text-base" data-id="element-264">
              โหลดความคิดเห็นอีก 5 รายการ
            </motion.button>
          </motion.div>}

        {!hasMore && comments.length > 5 && <p className="text-center text-gray-500 mt-6 md:mt-8 text-xs md:text-sm" data-id="element-265">
            คุณได้ดูความคิดเห็นทั้งหมดแล้ว
          </p>}
      </div>
    </section>;
}